import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration';

class DebtInvoiceAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'TaskGo';
  controllerName = 'DebtInvoices';

  /**
   * @param param
   * @returns
   */
  getDebtInvoice(budgetCode) {
    let request = {
      url: `${this.getAPIUrl()}/GetDebtInvoice/${budgetCode}`,
    };

    return httpClient.getAsync(request);
  }
  
  /**
   * @param param
   * @returns
   */
  getKeyPreview(transactionID) {
    let request = {
      url: `${this.getAPIUrl()}/GetKeyPreview/${transactionID}`,
    };

    return httpClient.getAsync(request);
  }
}

export default new DebtInvoiceAPI();
